const login = require('./queries/login')
const preRequisition = require('./queries/preRequisition')
const createDoctorNote = require('./queries/createDoctorNote')
module.exports = {
  login,
  preRequisition,
  createDoctorNote
}
